import { fetch } from "../../index";
import { singleLineup, multipleLineup } from "../../queries/allContentItems";

import { GRAPHQL_URL } from "../../constants";

/**
 * Fetches data from graphQL for a single lineup.
 * @param {object} options
 * @param {string} options.lineupSlug
 * @param {string} options.categorySlug
 * @param {string} options.subjectsSet
 * @param {string} options.tags
 * @param {string} [options.query=singleLineup]
 * @param {number} [options.page=1]
 * @param {number} [options.pageSize=10]
 */
export async function fetchSingleLineup({
    lineupSlug,
    categorySlug,
    concepts,
    subjectsSet,
    tags,
    query = singleLineup,
    page = 1,
    pageSize = 10,
}) {
    return fetch(GRAPHQL_URL, {
        query: query,
        variables: {
            lineupSlug,
            categorySlug,
            concepts,
            subjectsSet,
            tags,
            page,
            pageSize,
        },
    });
}

/**
 * Fetches data from graphQL for multiple lineups. Mainly accompanied with ContentListing component
 * @param {array} lineups
 *    @param {object} objects
 *       @param {string} title - used for ContentListing heading
 *       @param {string} link - url to link heading out to another destination
 *       @param {string} lineupID - used to uniquely identify query in response
 *       @param {string} lineupSlug - lineup to get data from
 *       @param {string} categorySlug - categorySlug to get data from
 * @param {number} pageSize - number of items to return per lineup
 */
export async function fetchMultipleLineups(lineups, pageSize) {
    return fetch(GRAPHQL_URL, {
        query: multipleLineup(lineups, pageSize),
    });
}
